<template>
    <div class="stepper-wrapper text-center">
        <ul v-if="stepper.steps.length">
            <li v-for="(step,index) in stepper.steps" :key="index" class="step" :class="[isCurrentStep(index), step.status ? step.status : '']">
                <div class="step-circle"></div>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "StepperComponent",
    components: {
    },
    computed: {
        ...mapGetters(['stepper'])
    },
    data: function () {
        return {
        };
    },
    methods: {
        isCurrentStep(index){
            // Check to see if the current step in the loop is the current step, if it is return the applicable class
            if((index + 1) == this.$route.params.step){
                return "current";
            }
        }
    }
};
</script>
